import React from "react";
import { useQuote } from "../context/QuoteContext";
import { Package, Maximize2, Camera, FileText, Wand2, MessageSquare } from "lucide-react";

const MODES = [
  { key: "objects", title: "Per oggetti", desc: "Seleziona gli oggetti dal catalogo manualmente", icon: Package },
  { key: "area", title: "Per area", desc: "Calcola il prezzo dalle dimensioni della stanza", icon: Maximize2 },
  { key: "image", title: "Da immagine", desc: "L'AI analizza una foto degli oggetti", icon: Camera },
  { key: "text", title: "Da testo", desc: "L'AI estrae gli oggetti da un testo incollato", icon: FileText },
];

export default function ModeSelector({ onOpenWizard }) {
  const { newQuote } = useQuote();
  return (
    <div>
      <h2 className="text-2xl font-display font-semibold tracking-tight mb-1">Nuovo preventivo</h2>
      <p className="text-slate-500 text-sm mb-5">Scegli come vuoi iniziare. Nuovo qui? Prova la <span className="font-medium text-[#1a5f5a]">Modalità guidata</span>.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {MODES.map((m) => {
          const Icon = m.icon;
          return (
            <div key={m.key}
              className="group bg-white border border-slate-200 rounded-lg p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all">
              <button onClick={() => newQuote(m.key)} data-testid={`mode-${m.key}`} className="text-left w-full">
                <div className="flex items-start gap-4">
                  <div className="h-12 w-12 rounded-lg bg-[#1a5f5a]/10 flex items-center justify-center group-hover:bg-[#1a5f5a] transition-colors">
                    <Icon className="h-6 w-6 text-[#1a5f5a] group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <h3 className="font-display font-semibold text-lg text-slate-900">{m.title}</h3>
                    <p className="text-sm text-slate-500 mt-0.5">{m.desc}</p>
                  </div>
                </div>
              </button>
              <button onClick={() => onOpenWizard?.(m.key)} data-testid={`mode-wizard-${m.key}`}
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[#1a5f5a] hover:text-[#134744] transition-colors">
                <Wand2 className="h-4 w-4" /> Modalità guidata
              </button>
            </div>
          );
        })}
      </div>

      <div className="mt-4">
        <div className="group bg-white border border-slate-200 rounded-lg p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all">
          <button onClick={() => newQuote("text_simple")} data-testid="mode-text_simple" className="text-left w-full">
            <div className="flex items-start gap-4">
              <div className="h-12 w-12 rounded-lg bg-[#1a5f5a]/10 flex items-center justify-center group-hover:bg-[#1a5f5a] transition-colors">
                <MessageSquare className="h-6 w-6 text-[#1a5f5a] group-hover:text-white transition-colors" />
              </div>
              <div>
                <h3 className="font-display font-semibold text-lg text-slate-900">Da testo (semplificato)</h3>
                <p className="text-sm text-slate-500 mt-0.5">Chat con l'assistente AI che segue le istruzioni StorMi e scrive il messaggio WhatsApp</p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
